module.exports = __webpack_public_path__ + "static/media/ektakth.80a3f95a.jpg";